import { render, staticRenderFns } from "./Articles.CarouselItem.vue?vue&type=template&id=b1d73808&scoped=true&"
import script from "./Articles.CarouselItem.vue?vue&type=script&lang=js&"
export * from "./Articles.CarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./Articles.CarouselItem.vue?vue&type=style&index=0&id=b1d73808&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d73808",
  null
  
)

export default component.exports